const FA_DIGITS = "۰۱۲۳۴۵۶۷۸۹";

export const timerSeconds = (timer, now = Date.now()) => {
  if (!timer || !timer.isRunning) return 0;
  const passed = (now - (timer.at ?? now)) / 1000;
  return Math.max(0, Math.floor((timer.elapsedSeconds ?? 0) + passed));
};

export const formatTimer = (seconds) => {
  const pad = (value) => String(value).padStart(2, "0");
  const hours = Math.floor(seconds / 3600);
  const text =
    (hours ? hours + ":" : "") +
    pad(Math.floor((seconds % 3600) / 60)) +
    ":" +
    pad(seconds % 60);
  return text.replace(/\d/g, (digit) => FA_DIGITS[Number(digit)]);
};
